export const ITEM_TIPO_PRODUCTO = 'Producto';
export const ITEM_TIPO_MANO_DE_OBRA = 'Mano De Obra';
